import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from '../services/common';
import { googleLogin } from '../services/auth';
import * as tokenServices from 'services/token';
import { useDispatch } from 'react-redux';
import { setLoginStatus } from '../store/actions/auth';

export const useGoogleLogin = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(googleLogin, {
    onSuccess: async response => {
      queryClient.clear();
      tokenServices.setUserToken(response.accessToken);
      dispatch(setLoginStatus());
      showSuccessNotification('Login successfully');
    },
  });
};
